import { render, staticRenderFns } from "./SagaPanel.vue?vue&type=template&id=53caed18&scoped=true"
import script from "./SagaPanel.vue?vue&type=script&lang=js"
export * from "./SagaPanel.vue?vue&type=script&lang=js"
import style0 from "./SagaPanel.vue?vue&type=style&index=0&id=53caed18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53caed18",
  null
  
)

export default component.exports